export default __webpack_public_path__ + "static/media/rocket_anim_53.2ed57efd.png";